import 'slick-carousel';


// WEBPACK FOOTER //
// ./scripts/autoload/_slick.js